import Model, { ID, IsoDateTime, JsonArray, JsonObject } from 'src/models/Model'

export default class CinemaDataMigrationData extends Model {
  static name = 'CinemaDataMigrationData'

  static paginate = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Data]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      rawRowData: {
        type: String,
        output: true,
        default: null
      },
      parsedRowData: {
        type: JsonObject,
        default () {
          return {
          }
        }
      },
      validateSuccess: {
        type: Boolean,
        output: true
      },
      validationMessage: {
        type: JsonArray,
        output: true,
        default: null
      },
      validatedAt: {
        type: IsoDateTime,
        output: true
      },
      parsedRowObject: {
        type: String,
        output: true
      },
      importSuccess: {
        type: Boolean,
        output: true
      },
      importResultMessage: {
        type: JsonArray,
        output: true,
        default: null
      },
      importedId: {
        type: ID,
        output: true,
        default: null
      },
      importedAt: {
        type: IsoDateTime,
        output: true
      }
    }

    this.computed = {
      validationStatus () {
        if (this.validateSuccess) {
          return { name: 'check', color: 'positive', tooltip: 'Validation Successful' }
        } else if (this.validateSuccess === false) {
          return { name: 'error', color: 'negative', tooltip: 'Validation Failed' }
        } else {
          return { name: 'hourglass_top', color: 'warning', tooltip: 'Queued, Waiting to be Processed' }
        }
      },
      importStatus () {
        if (this.importSuccess) {
          return { name: 'check', color: 'positive', tooltip: 'Import Completed' }
        } else if (this.importSuccess === false) {
          return { name: 'error', color: 'negative', tooltip: 'Import Failed' }
        } else {
          return { name: 'hourglass_top', color: 'warning', tooltip: 'Queued, Waiting to be Processed' }
        }
      },
      editable () {
        return !!this.importedAt
      }
    }
  }
}
